export default __webpack_public_path__ + "static/media/ic_download.f0683e87.svg";